import ReportOverview from './ReportOverview'
import withReportOverview from './withReportOverview'

const ConnectedReportOverview = withReportOverview(ReportOverview)

export { ConnectedReportOverview as ReportOverview }
